import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table, Radio, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateADCertificate, deleteTemplateADCertificate, putTemplateADCertificate
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentADCertificate = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [promptForCredentials, setPromptForCredentials] = useState<boolean>(true);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = () => {
        setShowTable(1)
        getTemplateADCertificate(templateId).then((res) => {
            if (res.hostName) {
                setShowTable(2);
                setPromptForCredentials(res?.promptForCredentials);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            putTemplateADCertificate(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateADCertificate(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("AD Certificate")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置活动目录证书")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentADDomain", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "90%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            labelCol={{ span: 20 }}
                            initialValues={{ enableAutoRenewal: false, keyIsExtractable: false }}
                        >
                            <Item label={t("Certificate Description")} name="description">
                                <Input />
                            </Item>

                            <Item label={t("CA Host Name")} name="hostName" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("Certificate Template")} name="certTemplate" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("用户证书填User, 电脑证书填Machine")}</>}>
                                <Input />
                            </Item>

                            <Item label={t("Certificate Authority")} name="certificateAuthority" extra={<><InfoCircleOutlined /> {t("比如CN=<your CA Name>")}</>}>
                                <Input />
                            </Item>

                            <Item label={t("EnableAutoRenewal")} name="enableAutoRenewal" rules={[{ required: true }]}>
                                <Radio.Group defaultValue={true}>
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>

                            <Item label={t("KeyIsExtractable")} name="keyIsExtractable" rules={[{ required: true }]}>
                                <Radio.Group defaultValue={true}>
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>

                            <Item label={t("PromptForCredentials")} name="promptForCredentials" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("只对类型为User的证书模板并且手动下载的描述文件适用")}</>}>
                                <Radio.Group defaultValue={true} onChange={(e) => { setPromptForCredentials(e.target.value) }}>
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>

                            {promptForCredentials && <>
                                <Item label={t("用户名")} name="userName" rules={[{ required: promptForCredentials }]}>
                                    <Input />
                                </Item>

                                <Item label={t("密码")} name="password" rules={[{ required: promptForCredentials }]}>
                                    <Input.Password />
                                </Item>
                            </>}
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentADDomain", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentADDomain", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>

    </>)
};